// import COMBO_DATA from "./combo"
import FALL_COLLECTION_DATA from "./fall-collection"
import REGULAR_COLLECTION_DATA from "./regular-collection"

const APPAREL_DATA = {
  // ...COMBO_DATA,
  ...FALL_COLLECTION_DATA,
  ...REGULAR_COLLECTION_DATA,
}
export default APPAREL_DATA
